import { IInventoryPage } from '../../inventory-page.interface';


export const SETTINGS_SUBSCRIPTIONS_PAGE: IInventoryPage = {
	'route': '/settings/subscriptions',
	'title': 'Subscriptions',
	'uiReference': [
		'Invoices',
		'Loading subscription records',
		'Close',
		'Subscriptions',
		'Review active plans, expired plans, and invoices.',
		'Add New Subscription',
		'No active subscriptions found',
		'- User ID',
		'- Subscription ID',
		'Activated',
		'Flying Upload Subscription',
		'Details on Flying Upload',
		'View Invoice',
		'Send to Mail',
		'Assigned by the support',
		'Package free of charge',
		'Add Subscription',
		'No expired subscriptions found',
		'Renew Subscription',
		'Loading subscription records...',
		'&times;',
		'See all Tutorials',
		'Research',
		'Events',
		'Trademark'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/subscriptions/subscriptions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/subscriptions/subscriptions.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/general/subscriptions/subscriptions.component.html'
	]
};
